import api from '../apis/api';
import getMessageFromApiError from '../util/getMessageFromApiError';

export const fetchArchivedJobs = async (
  sort_by,
  count,
  ascending,
  last_key_uuid,
  last_key_sort
) => {
  try {
    const res = await api.get('/job/archived', {
      params: {
        sort_by: sort_by,
        count: count,
        ascending,
        last_key_uuid,
        last_key_sort,
      },
    });
    return {
      jobs: res.data.jobs,
      last_key_uuid: res.data.last_key_uuid,
      last_key_sort: res.data.last_key_sort,
    };
  } catch (error) {
    const message = getMessageFromApiError(error);
    throw new Error(`API Error - ${message}`);
  }
};
